<template>
  <button
    type="button"
    class="p-0 flex justify-center items-center text-white border border-transparent rounded-full appearance-none control-button"
    :disabled="disabled"
    :class="[type, { active: isActive }]"
    @click="click"
  >
    <slot />
  </button>
</template>

<script lang="ts" setup>
defineProps({
  type: {
    type: String,
    default: 'dark',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isActive: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['click'])

function click(event: MouseEvent) {
  emit('click', event)
}
</script>

<style lang="stylus" scoped>
.control-button
  @apply bg-gray-700
  &:hover
    @apply bg-gray-600
  &:disabled
    @apply bg-gray-400 cursor-not-allowed

.danger
  @apply bg-red-800
  &:hover
    @apply bg-red-700

.dark
  @apply bg-gray-900 bg-opacity-60
  &:hover
    @apply bg-gray-700

.dark--inverse
  @apply bg-gray-800 bg-opacity-60
  &:hover
    @apply bg-gray-900

@media (hover: none)
  .control-button:hover
    @apply hover_bg-gray-700
  .danger
    @apply hover_bg-red-800
  .dark
    @apply hover_bg-gray-900

.active
  @apply bg-white text-gray-800 border border-gray-300 hover_bg-white

  &:hover, &:active
    @apply hover_bg-white
</style>
